var PREV_TAB_ID = 'paa_tab_id';

export { PREV_TAB_ID as default };
//# sourceMappingURL=index.js.map
